export default __webpack_public_path__ + "static/2151-8b3f56a4ae9f7c58dc6b8e4a944a768d.gif";